// NCI code mappings for quantity unit of measure
const quantityUnitOfMeasure: Record<string, string> = {
  C62412: 'Applicator',
  C54564: 'Blister',
  C64696: 'Caplet',
  C48480: 'Capsule',
  C64933: 'Each',
  C53499: 'Film',
  C48155: 'Gram',
  C69124: 'Gum',
  C48499: 'Implant',
  C62276: 'Insert',
  C48504: 'Kit',
  C120263: 'Lancet',
  C48506: 'Lozenge',
  C28253: 'Milligram',
  C28254: 'Milliliter',
  C48521: 'Packet',
  C65032: 'Pad',
  C48524: 'Patch',
  C120216: 'Pen Needle',
  C97717: 'Pre-filled Pen Syringe',
  C62609: 'Ring',
  C53502: 'Sponge',
  C53503: 'Stick',
  C48538: 'Strip',
  C48539: 'Suppository',
  C53504: 'Swab',
  C48540: 'Syringe',
  C48542: 'Tablet',
  C48548: 'Troche',
  C48551: 'Vial',
  C51672: 'Vial',
  C48549: 'Wafer',
  C38046: 'Unspecified',
}

/**
 * Parse NCI code to human-readable description for quantity unit of measure
 * @param code NCI code (e.g., 'C64933')
 * @returns Human-readable description (e.g., 'Each') or the code if not found
 */
export function parseQuantityUnitOfMeasure(code?: string): string {
  if (!code) return ''
  if (code === 'C38046') return ''
  return quantityUnitOfMeasure[code] || code
}

// C38046 ('Unspecified') is intentionally omitted — it's the very case the
// INVALID_UOM validator flags, so picking it as a resolution would defeat
// the purpose of the queue.
export const quantityUnitOfMeasureOptions: { label: string; value: string }[] = Object.entries(quantityUnitOfMeasure)
  .filter(([code]) => code !== 'C38046')
  .map(([value, label]) => ({ label, value }))
  .sort((a, b) => a.label.localeCompare(b.label))

/**
 * Format quantity with unit of measure
 * @param quantity The quantity value
 * @param uomCode The NCI code for unit of measure
 * @returns Formatted string (e.g., '4 Each' or '4 pens')
 */
export function formatQuantityWithUOM(quantity?: string | number, uomCode?: string): string {
  if (!quantity) return ''

  const uom = parseQuantityUnitOfMeasure(uomCode)
  if (!uom) return quantity.toString()

  // Special formatting for common units
  const formattedUOM = uom === 'Each' ? 'ea' : uom.toLowerCase()

  return `${quantity} ${formattedUOM}`
}
